module.exports = __webpack_public_path__ + "img/sakai.f2704c3.svg";